<rx-intuitive-teeth-orchestrator-layout>
	<div rx-intuitive-teeth-diagram-banner>
		<tlk-banner
			type="error"
			*ngIf="preTreatmentValidationError$ | async as errorKey"
			data-testid="pretreatment-validation-error-banner"
		>
			<div tlkBannerBody>
				{{ errorKey | translate }}
			</div>
		</tlk-banner>
	</div>

	<rx-intuitive-treatment-toolbar
		rx-intuitive-teeth-diagram-toolbar
		[showCopyFromToothMenu]="showCopyFromMenu$ | async"
		[currentOrchestratorViewMode]="orchestratorViewMode$ | async"
		[tableViewDisabled]="(isTableViewDisabled$ | async) ?? true"
		(viewModeSwitched)="changeOrchestratorViewMode($event)"
	/>

	<rx-intuitive-teeth-diagram
		rx-intuitive-teeth-diagram-diagram
		[upperJaw]="(upperJaw$ | async) ?? []"
		[lowerJaw]="(lowerJaw$ | async) ?? []"
		[chartReadOnly]="(chartReadOnly$ | async) ?? false"
		(toothClicked)="onToothClicked($event)"
		(resetSelectedRequested)="onResetSelectedRequested()"
	></rx-intuitive-teeth-diagram>

	<rx-intuitive-indication-buttons
		rx-intuitive-teeth-diagram-buttons
		[attr.data-bi-attr-selected-tooth-count]="(selectedToothIds$ | async)?.length || '0'"
		[indicationIds]="(indications$ | async) ?? []"
		[enabledIndicationIds]="(enabledIndications$ | async) ?? []"
		[selectedIndicationIds]="(selectedTeethIndicationIds$ | async) ?? []"
		[disabled]="(indicationButtonsDisabled$ | async) ?? false"
		[asLabel]="(indicationButtonsAsLabel$ | async) ?? false"
		(indicationSelected)="onIndicationSelected($event)"
	></rx-intuitive-indication-buttons>

	<tlk-banner
		rx-intuitive-teeth-diagram-buttons
		class="rx-intuitive-teeth-diagram__crown-ai-banner"
		type="info"
		*ngIf="isCrownAIBannerVisible$ | async"
	>
		<div tlkBannerLeft class="tlk-banner__left-content">
			<tlk-ai-crown-icon class="tlk-icon tlk-icon_size_l" />
		</div>
		<div tlkBannerTitle class="tlk-banner__title">{{ 'Awareness.CaptionBannerCrownAI' | translate }}</div>
		<div tlkBannerBody class="tlk-banner__body">{{ 'Awareness.FlexBannerCrownAI' | translate }}</div>
	</tlk-banner>

	<div rx-intuitive-teeth-diagram-panel>
        <rx-intuitive-tooth-editor-container/>
	</div>

	<rx-intuitive-teeth-diagram-footer
		rx-intuitive-teeth-diagram-footer
		[showBackButton]="(showPanelBack$ | async) ?? false"
		(back)="focusDiagram()"
	/>
</rx-intuitive-teeth-orchestrator-layout>
